import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://250498b2a063db35f7d5772051d96163@o4510692292034560.ingest.de.sentry.io/4510692293935184",
  sendDefaultPii: false,
});

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const error = event.error || new Error(event.message);
    Sentry.captureException(error, {
      extra: {
        source: 'window.onerror',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason =
      event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    Sentry.captureException(reason, {
      extra: {
        source: 'unhandledrejection',
      },
    });
  });
}

